import { motion } from 'framer-motion';
import styled from 'styled-components';

import { mediaTablet } from 'utils/styles/responsive';

export const QuoteSectionWrapper = styled.div<{ backgroundHexColor?: string }>`
  width: 100%;

  position: relative;
  overflow: hidden;

  background: ${({ backgroundHexColor, theme }) =>
    backgroundHexColor || theme.colors.black};
`;

export const QuoteWrapper = styled.div`
  margin: 10vh 15px;

  ${mediaTablet('margin: 20vw')};
`;

export const ImageWrapper = styled(motion.div)`
  position: absolute;
  width: 25vh;

  max-width: 320px;
  max-height: 320px;

  filter: brightness(75%);
  pointer-events: none;
`;
